<template>
    <window-chat
            @open="openedChat()"
            @close="closedChat()"
            :messages="messages"
            ref="windowChat"
            @scroll-top="loadMoreMessages()"
            @send="send($event)"
            :my-types="['user']"
            :count-unread="unreadMessages"
    ></window-chat>
</template>

<script>
    import WindowChat from "../ui/Chat/WindowChat";

    export default {
        components: {WindowChat},
        data() {
            return {
                messages: [],
                unreadMessages: 0
            }
        },
        watch: {
            unreadMessages(v) {
                this.$store.commit('setUnreadMessages', v);
            }
        },
        methods: {
            openedChat() {
                this.loadMessages();
                this.$socket.registerHandler('update_messages', this.loadMessages);

                if (this.$vuetify.breakpoint.xsOnly) {
                    let html = document.querySelector('html');
                    html.style.overflow = 'hidden';
                }
            },
            closedChat() {
                this.$socket.deleteHandler('update_messages');

                let html = document.querySelector('html');
                html.style.overflow = 'inherit';
            },
            loadMessages() {
                this.$store.dispatch('loadMessages', {params: {}})
                    .then(res => {
                        this.messages = res;
                        this.$refs.windowChat.scrollToBottom();
                    });
            },
            loadMoreMessages() {
                let id = this.messages[0].id;
                this.$store.dispatch('loadMessages', {params: {first_id: id}})
                    .then(res => {
                        if (res.length === 0) return;
                        this.messages = res.concat(this.messages);
                        this.$refs.windowChat.$refs.chat.scrollBlocking = true;
                        this.$refs.windowChat.scrollToMessage(id);
                        this.$nextTick(() => {
                            this.$refs.windowChat.$refs.chat.scrollBlocking = false;
                        });
                    });
            },
            send(msg) {
                this.$store.dispatch('createMessage', {
                    data: {
                        msg: msg,
                        time_zone: this.$store.state.user.timeZone
                    }
                })
                    .then(res => {
                        this.messages.push(res);
                        this.$refs.windowChat.$refs.chat.scrollToBottom();
                    })
                    .finally(() => this.$refs.windowChat.$refs.chat.loading = false);
            },
            countUnreadMessages() {
                this.$store.dispatch('countUnreadMessages')
                    .then(res => this.unreadMessages = res.count);
            }
        },
        created() {
            this.countUnreadMessages();
            this.$socket.registerHandler('count_unread_messages', v => {
                this.unreadMessages = v;
            })
        }
    }
</script>